import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
//import TableCell from '@mui/material/TableCell';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const ChineseClass = (props) => {

  const class_introduction = props.class_introduction;

  return (
    <>

        <Box height={100} />

          <Grid container spacing={0} alignItems="center" justify="center">
                <Grid item xs={2} />
                <Grid item xs={8}>
                    <Card>
                    <CardHeader title={class_introduction.课程名称}/>
                    <CardContent>
                      <Box textAlign={'center'}>
                        <Box textAlign={'center'}>
                          <Typography variant="body1" gutterBottom style={{ whiteSpace: 'pre-line' }}>
                          {class_introduction.课程介绍}
                          </Typography> 
                        </Box>
                        <Box textAlign={'center'}>
                          <Typography variant="body1" gutterBottom style={{ whiteSpace: 'pre-line' }}>
                          {class_introduction.教材}
                          </Typography> 
                        </Box>

                        <Box textAlign={'left'}>
                          <Typography variant="body1" gutterBottom  style={{ whiteSpace: 'pre-line' }}>
                          {class_introduction.考核方法}
                          </Typography> 
                        </Box>
                                              
                      </Box>

                    </CardContent>
                    </Card>

                </Grid> 
                <Grid item xs={2} />
          </Grid>
      

      <Box sx={{ height: '80px' }}></Box>
    </>
  )
}

export default ChineseClass;